"use client";

import * as React from 'react';
import LoadingOutlined from "@ant-design/icons/es/icons/LoadingOutlined";
import CheckOutlined from "@ant-design/icons/es/icons/CheckOutlined";
import CopyOutlined from "@ant-design/icons/es/icons/CopyOutlined";
import classNames from 'classnames';
import TransButton from '../../_util/transButton';
import Tooltip from '../../tooltip';
import { getNode, toList } from './util';
export default function CopyBtn(props) {
  const prefixCls = props.prefixCls,
    copied = props.copied,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? {} : _props$locale,
    onCopy = props.onCopy,
    iconOnly = props.iconOnly,
    tooltips = props.tooltips,
    icon = props.icon,
    loading = props.loading;
  const tooltipNodes = toList(tooltips);
  const iconNodes = toList(icon);
  const copiedText = locale.copied,
    copyText = locale.copy;
  const copyTitle = copied ? getNode(tooltipNodes[1], copiedText) : getNode(tooltipNodes[0], copyText);
  const systemStr = copied ? copiedText : copyText;
  const ariaLabel = typeof copyTitle === 'string' ? copyTitle : systemStr;
  return /*#__PURE__*/React.createElement(Tooltip, {
    key: "copy",
    title: copyTitle
  }, /*#__PURE__*/React.createElement(TransButton, {
    className: classNames(`${prefixCls}-copy`, {
      [`${prefixCls}-copy-success`]: copied,
      [`${prefixCls}-copy-icon-only`]: iconOnly
    }),
    onClick: onCopy,
    "aria-label": ariaLabel
  }, copied ? getNode(iconNodes[1], /*#__PURE__*/React.createElement(CheckOutlined, null), true) : getNode(iconNodes[0], loading ? /*#__PURE__*/React.createElement(LoadingOutlined, null) : /*#__PURE__*/React.createElement(CopyOutlined, null), true)));
}